export default __webpack_public_path__ + "static/media/SFProDisplay-Medium.22a99d36.woff2";